import { Box, Dialog, IconButton, Typography , Accordion, AccordionSummary, AccordionDetails} from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { AnteriorImage, FundusImage } from '../../../../Utility/Constants'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import SketchDiagram from '../../../../Components/Common Components/SketchDiagram'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const UmaAnteriorDiagram = (props) => {
  const [anteriorDia, setAnteriorDia] = useState({
    openAnteriorPopup: false,
    patientId: '',
    clinicId: '',
    appointmentId: '',
    doctorId: '',
    anteriorImage: AnteriorImage,
    prevAnteriorImage: AnteriorImage,
    dupAnteriorImage: JSON.stringify(AnteriorImage)
  })
  const [isCopyDisabled, setIsCopyDisabled] = useState(true)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apicalls = async () => {
    await getAnteriorDiagram()
    await getPrevAnteriorDiagram()
  }

  const getAnteriorDiagram = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ANTERIOR_DIAGRAM + `?appointment_id=${props?.props?.appointment_id}&doctor_id=${props?.props?.doctorID}`)

      if (response?.data?.status === 'success') {
        const data = response.data.data
        if (data?.image) {
          await getImageFromAws(data?.image)
        } else {
          if (AnteriorImage) {
            setAnteriorDia((prev) => ({ ...prev, anteriorImage: AnteriorImage, dupAnteriorImage: JSON.stringify(AnteriorImage) }))
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevAnteriorDiagram = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ANTERIOR_DIAGRAM_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        const data = response.data.data
        if (data?.image) {
          await getPrevImageFromAws(data?.image, 'prev')
          setIsCopyDisabled(false);
        } else {
          if (AnteriorImage) {
            setAnteriorDia((prev) => ({ ...prev, prevAnteriorImage: AnteriorImage }))
          }
          setIsCopyDisabled(true)
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getImageFromAws = async (doc_key, type) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key))
      if (response?.data?.status === 'success') {
        let data = response.data
        // if (type === 'prev') {
        //   setAnteriorDia((prev) => ({ ...prev, prevAnteriorImage: data?.data }))
        // } else {
        setAnteriorDia((prev) => ({ ...prev, anteriorImage: data?.data, dupAnteriorImage: JSON.stringify(data?.data) }))
        props.setAccordionOpen(data?.data ? true : false);
        // }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevImageFromAws = async (doc_key, type) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key))
      if (response?.data?.status === 'success') {
        let data = response.data
        setAnteriorDia((prev) => ({ ...prev, prevAnteriorImage: data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  };

  const postAnteriorDiagram = async (propsData) => {
    try {
      let drawings = [];
      if (propsData) {
        drawings.push(propsData);
        var lengths = (drawings.length) - 1
        let data = new FormData();
        data.append('appointment_id', props?.props?.appointment_id);
        data.append('image', dataURItoBlob(drawings[lengths]));
        data.append('image_json', (JSON.stringify(propsData)));

        const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_ANTERIOR_DIAGRAM)
        if (response?.data?.status === 'success') {
          successMessage(response?.data?.message)
          await getAnteriorDiagram()
          setAnteriorDia((prev) => ({ ...prev, openAnteriorPopup: false }))
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const deleteAnteriorDiagram = async (propsData) => {
    try {
      let drawings = [];
      if (propsData) {
        drawings.push(propsData);
        var lengths = (drawings.length) - 1
        let data = new FormData();
        data.append('appointment_id', props?.props?.appointment_id);
        data.append('image', dataURItoBlob(drawings[lengths]));
        data.append('image_json', (JSON.stringify(propsData)));

        const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_ANTERIOR_DIAGRAM)
        if (response?.data?.status === 'success') {
          successMessage(response?.data?.message)
          await getAnteriorDiagram()
          setAnteriorDia((prev) => ({ ...prev, openAnteriorPopup: false }))
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const renderAnteriorPopup = () => {
    try {
      return (
        <Dialog open={anteriorDia.openAnteriorPopup} maxWidth="md" fullWidth>
          <Box className='doc_diagram_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Anterior Diagram</Typography>
                <IconButton emed_tid='dia_cpy' disabled={isCopyDisabled}
                  onClick={() => setAnteriorDia((prev) => ({ ...prev, anteriorImage: anteriorDia.prevAnteriorImage }))}
                ><ContentCopyIcon color={isCopyDisabled ? 'disabled' : 'primary'} />
                </IconButton>
              </Box>
              <IconButton onClick={() => setAnteriorDia((prev) => ({ ...prev, openAnteriorPopup: false, anteriorImage: JSON.parse(anteriorDia.dupAnteriorImage) }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'}>
              <SketchDiagram
                onSave={postAnteriorDiagram}
                onDelete={deleteAnteriorDiagram}
                image={anteriorDia.anteriorImage}
                defaultImage={AnteriorImage}
              />
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font'>Anterior Diagram</Typography>
              <Box component={'div'} display={'flex'}>
                <IconButton emed_tid='dia_popup'
                  disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnteriorDia((prev) => ({ ...prev, openAnteriorPopup: true }))
                  }}
                ><AddCircleIcon color='primary' /></IconButton>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box component={'div'} display={'flex'} height={'45dvh'} justifyContent={'center'} alignItems={'center'}>
              <Box component={'img'} src={anteriorDia?.anteriorImage} alt='image' width={'100%'} />
            </Box>
          </AccordionDetails>
        </Accordion>
        {renderAnteriorPopup()}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
}

export default UmaAnteriorDiagram